import React from 'react';
import BreadcrumbComponent from '@views/components/breadcrumb/Breadcrumb';

export const Breadcrumb = () => (
  <BreadcrumbComponent
    options={[
      {
        name: 'Tìm kiếm',
        active: true,
      },
    ]}
  />
);

export default Breadcrumb;
